import { Link } from 'react-router-dom'
import { cn } from '@/shared/utils'

interface LogoProps {
  /** Size variant: 'sm', 'md', 'lg', or custom className */
  size?: 'sm' | 'md' | 'lg' | 'default'
  /** Additional CSS classes */
  className?: string
  /** Optional link destination. If provided, logo will be wrapped in a Link */
  to?: string
  /** Alt text for the logo image */
  alt?: string
}

const sizeClasses = {
  sm: 'h-6 w-auto',
  md: 'h-10 sm:h-12 md:h-14 w-auto max-w-full',
  lg: 'h-12 sm:h-14 md:h-16 w-auto max-w-full',
  default: 'h-10 sm:h-12 md:h-14 w-auto max-w-full',
}

export function Logo({ 
  size = 'default', 
  className, 
  to = '/',
  alt = 'SitRepp.io'
}: LogoProps) {
  const sizeClass = sizeClasses[size]
  const logoElement = (
    <img
      src="/favicon.png"
      alt={alt}
      className={cn(sizeClass, 'object-contain', className)}
    />
  )

  if (to) {
    return (
      <Link to={to} className="flex items-center flex-shrink-0">
        {logoElement}
      </Link>
    )
  }

  return logoElement
}

